import {
  DaimlerCSBold,
  DaimlerCSBoldItalic,
  DaimlerCSBoldItalicNew,
  DaimlerCSBoldNew,
  DaimlerCSDemi,
  DaimlerCSDemiItalic,
  DaimlerCSDemiItalicNew,
  DaimlerCSDemiNew,
  DaimlerCSExtraBold,
  DaimlerCSExtraBoldItalic,
  DaimlerCSExtraBoldItalicNew,
  DaimlerCSExtraBoldNew,
  DaimlerCSItalic,
  DaimlerCSItalicNew,
  DaimlerCSLight,
  DaimlerCSLightItalic,
  DaimlerCSLightItalicNew,
  DaimlerCSLightNew,
  DaimlerCSRegular,
  DaimlerCSRegularNew
} from '../fonts';

// TODO: consider supporting all types of fonts
export const fonts = `
  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSExtraBoldItalicNew}') format("woff2"),
        url('${DaimlerCSExtraBoldItalic}') format("woff");
    font-weight: 800;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSExtraBoldNew}') format("woff2"),
        url('${DaimlerCSExtraBold}') format("woff");
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSBoldItalicNew}') format("woff2"),
        url('${DaimlerCSBoldItalic}') format("woff");
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSBoldNew}') format("woff2"),
        url('${DaimlerCSBold}') format("woff");
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSDemiItalicNew}') format("woff2"),
        url('${DaimlerCSDemiItalic}') format("woff");
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSDemiNew}') format("woff2"),
        url('${DaimlerCSDemi}') format("woff");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSLightItalicNew}') format("woff2"),
        url('${DaimlerCSLightItalic}') format("woff");
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSLightNew}') format("woff2"),
        url('${DaimlerCSLight}') format("woff");
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSItalicNew}') format("woff2"),
        url('${DaimlerCSItalic}') format("woff");
    font-weight: normal;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'DaimlerCS';
    src: url('${DaimlerCSRegularNew}') format("woff2"),
        url('${DaimlerCSRegular}') format("woff");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  :root, html {
    font-size: 10px;
  }

  body {
    font-family: 'DaimlerCS', 'Calibri', 'Arial', 'Verdana', 'sans-serif';
    font-size: 1rem;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body.use-emoji-fallback {
    font-family: 'DaimlerCS', 'Calibri', 'Arial', 'Verdana', 'sans-serif', 'busstore-emojis';
  }
`;
